import React from 'react';

import { DynamicProductTable } from '../../_dynamic';

import { tableHead } from './constants';
import ProductItem from './item';

export const FixedIncomeTable = (props) => {
  return (
    <DynamicProductTable
      {...props}
      ProductItem={ProductItem}
      tableHeadItems={tableHead}
      tabletColumns={4}
      mobileColumns={2}
      mobileRows={2}
      productType="fixedIncome"
      mobileFields={[
        { key: 'fixedIncomeIssuerName', label: 'Nome' },
        { key: 'tags', label: 'Bloqueios' },
      ]}
    />
  );
};
